import * as React from 'react';

import type {Status} from 'nutshell-graphql-types';

import {PrimaryConfigureCtaButton} from './primary-configure-cta-button';
import type {PageType} from './types';

import styles from './analytics-status.module.css';

type Props = {
    pageType: PageType;
    status: Status;
    onOpenEmbedAnalyticsModal: () => void;
    onClosePopover: () => void;
};

export function NewVersionAvailableBody(props: Props) {
    return (
        <>
            <div className={styles.text}>
                <div className='mb-16'>
                    Your current snippet still works, but ad blockers may prevent it from loading
                    for your visitors.
                </div>
                <div>
                    By configuring your domain and re-embedding, you can recover up to 11% more
                    leads and sales.
                    <PrimaryConfigureCtaButton
                        pageType={props.pageType}
                        status={props.status}
                        onClosePopover={props.onClosePopover}
                        onOpenEmbedAnalyticsModal={props.onOpenEmbedAnalyticsModal}
                    />
                </div>
            </div>
        </>
    );
}
